module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0122.jpg?v=d48469cb";